import HomePageSearchModal from '@components/Home/HomePageSearchModal'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'

const SearchIconAndModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <>
      <button
        aria-label="Arama Yap"
        title="Arama Yap"
        type="button"
        className="p-2.5 transition-all duration-200 rounded-xl hover:bg-primary-50 dark:hover:bg-primary-dark-400/50 hover:scale-105 active:scale-95"
        onClick={() => setIsModalOpen(true)}
      >
        <FaSearch size={24} className="text-primary-dark dark:text-primary-100" />
      </button>
      <HomePageSearchModal
        isOpen={isModalOpen}
        triggerCloseModal={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default SearchIconAndModal
